import { GiftCardDuration } from '../models/enum/voucher-durations.enum';

export const defineDisplayedVoucherDuration = (
  voucherDuration: GiftCardDuration
): string => {
  switch (voucherDuration) {
    // case GiftCardDuration.ThreeMonths:
    //   return 'dashboard.subscription.voucher.durations.threeMonths';
    case GiftCardDuration.SixMonths:
      return 'dashboard.subscription.voucher.durations.sixMonths';
    case GiftCardDuration.OneYear:
      return 'dashboard.subscription.voucher.durations.oneYear';
    default:
      return 'dashboard.subscription.voucher.durations.lifetimeAccess';
  }
};
